export enum EsiaStatus {
  NotRequested = '',
  Requested = 'requested',
  NotReceived = 'not_received',
  Received = 'received',
}

export enum EsiaDataRequestFailReason {
  NotFail = '',
  AccessDenied = 'access_denied',
  Blocked = 'blocked',
  NotTrusted = 'not_trusted',
  DtBirth = 'dt_birth',
  Underage = 'underage',
}
